import TOOLS from '@helpers/tools'
import FILTERS from '@helpers/filters'

export default function lpVivantagensDataLayerBody(stateId, locations, imoveis, path) {
  if (typeof window !== 'undefined') {
    window.dataLayer.push({ imoveis: undefined })
    window.dataLayer.push({
      event: 'dados-imoveis',
      pagepath: path,
      pageType: 'vivantagens',
      estado: 'sao-paulo',
      imoveis: imoveis.map((h, index) => {
        return {
          id: h.ImovelId,
          nome: TOOLS.slugify(h.Nome),
          bairro: TOOLS.slugify(h.Endereco.Bairro),
          cidade: TOOLS.slugify(h.Endereco.Cidade),
          estado: TOOLS.slugify(h.Endereco.Estado),
          areaprivativa: h.AreaPrivativaM2 ? TOOLS.slugify(h.AreaPrivativaM2) : undefined,
          dormitorios: TOOLS.slugify(h.Quartos),
          vagas: h.VagasGaragem,
          valor: h.PrecoMinimo ? FILTERS.moneyBi(h.PrecoMinimo) : undefined,
          status: h.Status ? TOOLS.slugify(h.Status) : undefined,
          position: index,
        }
      }),
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/BI/lpVivantagensDataLayerBody.js